import translations from './translations';

const contentProvider = language => {
  const content = translations[language];
  return {
    frontage: content.frontage,
    rooms: content.rooms,
    restaurants: content.restaurants,
    offers: content.offers,
    team: content.frontage.team,
    general: content.general,
    info: content.general.info,
    booking: content.general.booking,
    navigation: content.navigation,

    metatags: page => content.metatags[page],
    room: id => content.rooms.find(room => room.id === id),
    restaurant: id => content.restaurants.find(item => item.id === id),
  };
};

export default contentProvider;